import React from "react";

import Icon from "../Icon";
import { fundStatusColor, fundStatusLabel } from "../../helpers/fund";

const MedicationFunds = (props) => {
  return (
    <div className="Glossary-definition">
      <div className="Glossary-definition-inner">
        <div className="Glossary-definition-triangle"></div>
        <p className="f-label c-purple u-mb2">Disease Funds</p>

        <ul>
          {props.medication.funds.map((diseaseFund, i) => (
            <li className="u-mt2" key={i}>
              <div className="Glossary-definitionLinkWrapper">
                <a className="Glossary-definition-link" href={diseaseFund.permalink}>
                  {diseaseFund.Fund_Name}{" "}
                </a>
              </div>
              <p
                className={`Glossary-definition-label f-label-small Glossary-definition-label--${fundStatusColor(
                  diseaseFund
                )}`}
              >
                {fundStatusLabel(diseaseFund)}
              </p>
            </li>
          ))}
        </ul>

        <button
          onClick={(event) => props.toggleOpen(event)}
          className="Glossary-definition-close"
        >
          <span className="u-screenreader">close</span>
          <Icon name="close" width="12" height="12" />
        </button>
      </div>
    </div>
  );
};

export default MedicationFunds;
